import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemInformationListingShowDetails } from '../../../shared-models';
import { CellRendererIndexNameCustomParams } from '../models/cell-renderer-index-name-custom-params.interface';

@Component({
  selector: 'grid-ui-cell-renderer-index-name',
  templateUrl: './cell-renderer-index-name.component.html',
  styleUrls: ['./cell-renderer-index-name.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CellRendererIndexNameComponent implements ICellRendererAngularComp {
  public indexName = '';
  public updatedQuarter: string | null = null;
  public showInfoIcon = false;

  private cellValue?: CellRendererIndexNameCustomParams;

  public refresh(): boolean {
    return false;
  }

  public agInit(params: CellRendererIndexNameCustomParams): void {
    this.cellValue = params;
    this.indexName = params.data.name;
    this.showInfoIcon = params.showInfoIcon;
    this.updatedQuarter = params.data.edition === params.currentEdition ? params.currentQuarter : null;
  }

  public clickInfoIcon(): void {
    this.cellValue?.actionHandler(new ItemInformationListingShowDetails(this.cellValue.data.id));
  }
}
